import { ROLES } from "./../../../model/user";
import store from "@/store";
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import AdminLayout from "@/sites/admin/layout/qMaster.vue";
import LoginPage from "@/sites/admin/pages/login.vue";
import UserIndex from "@/sites/admin/pages/users/index.vue";
import AlbumIndex from "@/sites/admin/pages/albums/index.vue";
import AlbumEdit from "@/sites/admin/pages/albums/edit.vue";

import BlogIndex from "@/sites/admin/pages/blogs/index.vue";
import BlogEdit from "@/sites/admin/pages/blogs/edit.vue";
import BlogPreview from "@/sites/admin/pages/blogs/preview.vue";

import FileIndex from "@/sites/admin/pages/files/index.vue";
import FileEdit from "@/sites/admin/pages/files/edit.vue";

import GroupIndex from "@/sites/admin/pages/groups/index.vue";
import GroupEdit from "@/sites/admin/pages/groups/edit.vue";

import InfoIndex from "@/sites/admin/pages/info/index.vue";
import PdfIndex from "@/sites/admin/pages/pdfs/index.vue";
import MemberIndex from "@/sites/admin/pages/members/index.vue";
import ErrorPage from "@/sites/admin/pages/error.vue";
import NotFound from "@/sites/admin/pages/notFound.vue";
import Invited from "@/sites/admin/pages/invited/index.vue";

import ResetPassword from "@/sites/admin/pages/resetPassword.vue";
import ResetPasswordExpired from "@/sites/admin/pages/resetPasswordExpired.vue";

Vue.use(VueRouter);

const adminRouter: Array<RouteConfig> = [
  {
    path: "/admin",
    name: "admin",
    component: AdminLayout,
    meta: {
      allowRole: [],
    },
    children: [
      {
        path: "user",
        name: "admin.user",
        component: UserIndex,
        meta: {
          pageTitle: "ユーザー管理 | WENAVI管理者専用画面",
          title: "ユーザー管理 | WENAVI管理者専用画面",
          subTitle: "ユーザー管理 | WENAVI管理者専用画面",
          bodyClass: "mb__admin User",
          permission: [],
        },
      },
      {
        path: "album",
        name: "admin.album",
        component: AlbumIndex,
        meta: {
          pageTitle: "アルバム管理 | WENAVI管理者専用画面",
          title: "アルバム管理 | WENAVI管理者専用画面",
          subTitle: "アルバム管理 | WENAVI管理者専用画面",
          bodyClass: "mb__admin Album",
          permission: [],
        },
      },
      {
        path: "album/edit/:id",
        name: "admin.album.edit",
        component: AlbumEdit,
        meta: {
          pageTitle: "アルバム管理 | WENAVI管理者専用画面",
          title: "アルバム管理 | WENAVI管理者専用画面",
          subTitle: "アルバム管理 | WENAVI管理者専用画面",
          bodyClass: "mb__admin Album",
          permission: [],
        },
      },
      {
        path: "album/add",
        name: "admin.album.add",
        component: AlbumEdit,
        meta: {
          pageTitle: "アルバム管理 | WENAVI管理者専用画面",
          title: "アルバム管理 | WENAVI管理者専用画面",
          subTitle: "アルバム管理 | WENAVI管理者専用画面",
          bodyClass: "mb__admin Album",
          permission: [],
        },
      },
      {
        path: "blog",
        name: "admin.blog",
        component: BlogIndex,
        meta: {
          pageTitle: "投稿管理 | WENAVI管理者専用画面",
          title: "投稿管理 | WENAVI管理者専用画面",
          subTitle: "投稿管理 | WENAVI管理者専用画面",
          bodyClass: "mb__admin Blog",
          permission: [],
        },
      },
      {
        path: "blog/create",
        name: "admin.blog-create",
        component: BlogEdit,
        meta: {
          pageTitle: "ブログ管理 | WENAVI管理者専用画面",
          title: "ブログ管理 | WENAVI管理者専用画面",
          subTitle: "ブログ管理 | WENAVI管理者専用画面",
          bodyClass: "mb__admin Blog",
          permission: [],
        },
      },
      {
        path: "blog/:id([0-9]+)",
        name: "admin.blog-edit",
        component: BlogEdit,
        meta: {
          pageTitle: "ブログ管理 | WENAVI管理者専用画面",
          title: "ブログ管理 | WENAVI管理者専用画面",
          subTitle: "ブログ管理 | WENAVI管理者専用画面",
          bodyClass: "mb__admin Blog",
          permission: [],
        },
      },
      {
        path: "file",
        name: "admin.file",
        component: FileIndex,
        meta: {
          pageTitle: "ファイル管理 | WENAVI管理者専用画面",
          title: "ファイル管理 | WENAVI管理者専用画面",
          subTitle: "ファイル管理 | WENAVI管理者専用画面",
          bodyClass: "mb__admin File",
          permission: [],
        },
      },
      {
        path: "file/edit/:id",
        name: "admin.file.edit",
        component: FileEdit,
        meta: {
          pageTitle: "ファイル管理 | WENAVI管理者専用画面",
          title: "ファイル管理 | WENAVI管理者専用画面",
          subTitle: "ファイル管理 | WENAVI管理者専用画面",
          bodyClass: "mb__admin File",
          permission: [],
        },
      },
      {
        path: "file/add",
        name: "admin.file.add",
        component: FileEdit,
        meta: {
          pageTitle: "ファイル管理 | WENAVI管理者専用画面",
          title: "ファイル管理 | WENAVI管理者専用画面",
          subTitle: "ファイル管理 | WENAVI管理者専用画面",
          bodyClass: "mb__admin File",
          permission: [],
        },
      },
      {
        path: "group",
        name: "admin.group",
        component: GroupIndex,
        meta: {
          pageTitle: "グループ管理 | WENAVI管理者専用画面",
          title: "グループ管理 | WENAVI管理者専用画面",
          subTitle: "グループ管理 | WENAVI管理者専用画面",
          bodyClass: "mb__admin Group",
          permission: [],
        },
      },
      {
        path: "group/edit/:id",
        name: "admin.group-edit",
        component: GroupEdit,
        meta: {
          pageTitle: "グループ管理 | WENAVI管理者専用画面",
          title: "グループ管理 | WENAVI管理者専用画面",
          subTitle: "グループ管理 | WENAVI管理者専用画面",
          bodyClass: "mb__admin Group",
          permission: [],
        },
      },
      {
        path: "group/create",
        name: "admin.group-create",
        component: GroupEdit,
        meta: {
          pageTitle: "グループ管理 | WENAVI管理者専用画面",
          title: "グループ管理 | WENAVI管理者専用画面",
          subTitle: "グループ管理 | WENAVI管理者専用画面",
          bodyClass: "mb__admin Group",
          permission: [],
        },
      },
      {
        path: "info",
        name: "admin.info",
        component: InfoIndex,
        meta: {
          pageTitle: "グループ情報 | WENAVI管理者専用画面",
          title: "グループ情報 | WENAVI管理者専用画面",
          subTitle: "グループ情報 | WENAVI管理者専用画面",
          bodyClass: "mb__admin Info",
          permission: [],
        },
      },
      {
        path: "pdf",
        name: "admin.pdf",
        component: PdfIndex,
        meta: {
          pageTitle: "グループ情報 | WENAVI管理者専用画面",
          title: "グループ情報 | WENAVI管理者専用画面",
          subTitle: "グループ情報 | WENAVI管理者専用画面",
          bodyClass: "mb__admin PDF",
          permission: [],
        },
      },
      {
        path: "member",
        name: "admin.member",
        component: MemberIndex,
        meta: {
          pageTitle: "会員管理 | WENAVI管理者専用画面",
          title: "会員管理 | WENAVI管理者専用画面",
          subTitle: "会員管理 | WENAVI管理者専用画面",
          bodyClass: "mb__admin Member",
          permission: [],
        },
      },
    ],
  },
  {
    path: "/admin/blog/preview",
    name: "admin.blog-preview",
    component: BlogPreview,
    meta: {
      pageTitle: "ブログ管理 | WENAVI管理者専用画面",
      title: "ブログ管理 | WENAVI管理者専用画面",
      subTitle: "ブログ管理 | WENAVI管理者専用画面",
      bodyClass: "Group",
      permission: [],
    },
  },
  {
    path: "/login",
    name: "login",
    component: LoginPage,
    meta: {
      allowRole: [],
      pageTitle: "WENAVI管理画面",
      title: "WENAVI管理画面",
      subTitle: "WENAVI管理画面",
      bodyClass: "mb__admin mb__login",
      permission: [],
    },
  },
  {
    path: "/logout",
    name: "logout",
    // component: LoginPage,
    meta: {
      allowRole: [],
      pageTitle: "WENAVI管理画面",
      title: "WENAVI管理画面",
      subTitle: "WENAVI管理画面",
      bodyClass: "mb__admin mb__login",
      permission: [],
    },
  },
  {
    path: "/admin/invited/:group_id-:token",
    name: "admin.invited",
    component: Invited,
    meta: {
      pageTitle: "WENAVI管理画面",
      title: "WENAVI管理画面",
      subTitle: "WENAVI管理画面",
      bodyClass: "mb__admin mb__login",
      permission: [],
    },
  },
  {
    path: "/admin/:group_id(\\d+)",
    name: "admin.login",
    component: LoginPage,
    meta: {
      allowRole: [],
      pageTitle: "WENAVI管理画面",
      title: "WENAVI管理画面",
      subTitle: "WENAVI管理画面",
      bodyClass: "mb__admin mb__login",
      permission: [],
    },
  },
  {
    path: "*",
    redirect: "admin",
  },
  {
    path: "/not-found",
    name: "notFound",
    meta: {
      bodyClass: "ErrorBox",
    },
    component: NotFound,
  },
  {
    path: "/error",
    name: "error",
    meta: {
      bodyClass: "ErrorBox",
    },
    component: ErrorPage,
  },
  {
    path: "/reset-password",
    name: "admin.resetPassword",
    meta: {
      allowRole: [],
      pageTitle: "WENAVI管理画面",
      title: "WENAVI管理画面",
      subTitle: "WENAVI管理画面",
      bodyClass: "mb__admin mb__login",
      permission: [],
    },
    component: ResetPassword,
  },
  {
    path: "/reset-password/expired",
    name: "admin.resetPassword.expired",
    meta: {
      allowRole: [],
      pageTitle: "WENAVI管理画面",
      title: "WENAVI管理画面",
      subTitle: "WENAVI管理画面",
      bodyClass: "mb__admin mb__login",
      permission: [],
    },
    component: ResetPasswordExpired,
  },
];

const routes = [...adminRouter];
const router = new VueRouter({
  mode: "history",
  // base: process.env.NODE_ENV === "development" ? process.env.BASE_URL : "",
  routes,
});

router.beforeEach(async (to, from, next) => {
  store.dispatch("Router/setPreviousRouter", from);

  if (!to.name) {
    if (!store.state.Auth.token) {
      next({
        name: "login",
      });
      return;
    } else {
      if (store.state.Auth.role == ROLES.GROUP_ADMIN) {
        next({ name: "admin.info" });
        return;
      }

      next({
        name: "admin.user",
      });
      return;
    }
  }

  if (
    to.name !== "login" &&
    to.name !== "admin.login" &&
    to.name !== "admin.resetPassword" &&
    to.name !== "admin.resetPassword.expired" &&
    to.name !== "admin.invited" &&
    !store.state.Auth.token
  ) {
    next({
      name: "login",
    });
    return;
  }
  if (
    (to.name === "login" ||
      to.name === "admin.login" ||
      to.name === "admin.invited" ||
      to.name === "admin.resetPassword" ||
      to.name === "admin.resetPassword.expired") &&
    store.state.Auth.token
  ) {
    if (!localStorage.getItem("token")) {
      store.dispatch("Auth/logout");
      next();
    }
    if (store.state.Auth.role == ROLES.GROUP_ADMIN) {
      let groupId = null;
      if (to.name === "login") {
        groupId = to.query.token?.toString().split(".")[1];
      }

      if (
        store.state.Auth.groupUsers.filter((item) => {
          return item.id == groupId;
        }).length > 0
      ) {
        store.dispatch("Auth/updateUsingGroup", groupId);
      }
      next({ name: "admin.info" });
      return;
    }

    next({
      name: "admin.user",
    });
    return;
  }

  next();
});

router.afterEach((to) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.pageTitle || "";
    document.body.setAttribute("class", to.meta.bodyClass || "");
    if (document.querySelector("#top")) {
      document.querySelector("#top").setAttribute("class", "mb__admin");
    }
  });
});

export default router;
